"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserSigner = void 0;
const errors_1 = require("./errors");
const userAddress_1 = require("./userAddress");
const userKeys_1 = require("./userKeys");
const userWallet_1 = require("./userWallet");
/**
 * ed25519 signer
 */
class UserSigner {
    constructor(secretKey) {
        this.secretKey = secretKey;
    }
    static fromWallet(keyFileObject, password, addressIndex) {
        const secretKey = userWallet_1.UserWallet.decrypt(keyFileObject, password, addressIndex);
        return new UserSigner(secretKey);
    }
    static fromPem(text, index = 0) {
        let secretKey = userKeys_1.UserSecretKey.fromPem(text, index);
        return new UserSigner(secretKey);
    }
    sign(data) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const signature = this.secretKey.sign(data);
                return signature;
            }
            catch (err) {
                throw new errors_1.ErrSignerCannotSign(err);
            }
        });
    }
    /**
     * Gets the address of the signer.
     */
    getAddress() {
        const bech32 = this.secretKey.generatePublicKey().toAddress().bech32();
        return userAddress_1.UserAddress.fromBech32(bech32);
    }
}
exports.UserSigner = UserSigner;
//# sourceMappingURL=userSigner.js.map